<top-navig [displayLogo]="false" title="Profile"></top-navig>
<div class="profil" [@fade]="true">
    <div class="container head">
        <div class="row block" id="profile">
            <div class="col-xs-12">
                <h3 class="heading">Mes informations personnelles :</h3>
                <hr class="half_space">
                <div class="row">
                    <div class="col-xs-12 cont-l-per">
                        <div class="helf">
                            <img src="assets/images/profil.png" width="56px" alt="profil">
                        </div>
                        <span class="info">
                            Pour Modifier vos informations, merci de <a class="cursor-pointer"
                                (click)="updateInfo=true">cliquer ici</a>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 cont-r-per">
                        <div class="content-r">
                            <div class="row mb-22">
                                <div class="col-xs-4">
                                    <label>Email :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="text" *ngIf="!updateInfo" readonly [(ngModel)]="customer.email"
                                        value="">
                                    <input type="text" class="inpt" *ngIf="updateInfo" [(ngModel)]="customer.email"
                                        value="">
                                </div>
                            </div>
                            <div class="row mb-22">
                                <div class="col-xs-4">
                                    <label>Nom :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="text" *ngIf="!updateInfo" readonly [(ngModel)]="customer.lastname"
                                        value="">
                                    <input type="text" class="inpt" *ngIf="updateInfo" [(ngModel)]="customer.lastname"
                                        value="">
                                </div>
                            </div>
                            <div class="row mb-22">
                                <div class="col-xs-4">
                                    <label>Prénom :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="text" *ngIf="!updateInfo" readonly [(ngModel)]="customer.firstname"
                                        value="">
                                    <input type="text" class="inpt" *ngIf="updateInfo" [(ngModel)]="customer.firstname"
                                        value="">
                                </div>
                            </div>
                            <div class="row mb-22">
                                <div class="col-xs-4">
                                    <label>Téléphone :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="text" *ngIf="!updateInfo" readonly [(ngModel)]="customer.phone"
                                        value="">
                                    <input type="text" class="inpt" *ngIf="updateInfo" [(ngModel)]="customer.phone"
                                        value="">
                                </div>
                            </div>
                            <div class="row " *ngIf="updateInfo">
                                <div class="col-xs-4">
                                    <label>Entrer votre mot de passe pour valider la modification :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="password" class="inpt" placeholder="Mot de passe"
                                        [(ngModel)]="customer.oldPassword" value="">
                                </div>
                            </div>
                            <div class="row" *ngIf="updateInfo">
                                <div class="col-xs-4">
                                </div>
                                <div class="col-xs-8">
                                    <div class="valider">
                                        <button id="validate" class="btn" (click)="updateUser()">Valider</button>
                                        <button id="cancel" class="btn" (click)="updateInfo=false"> Annuler</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row block" id="my-address">
            <div class="col-xs-12">
                <h3 class="heading">Mes adresses :</h3>
                <button class="btn" title="Ajouter" (click)="addAddress()">
                    <img src="assets/images/icons/add.png" alt="">
                </button>
                <hr class="half_space half_space_fix_w">
                <div *ngIf="address?.length==0" class="text-center">
                    <p>Aucune adresse pour le moment</p>
                </div>
                <div class="content-address" *ngIf="address?.length>0">
                    <div class="list" *ngFor="let address of address;let i=index">
                        <div class="circle"></div>
                        <div class="amount"><span>{{address.postalCode}}</span></div>
                        <div class="body">
                            <span>
                                <span class="marg-l">{{address.streetNumber}},</span>
                                <span class="marg">{{address.streetName}},</span><br>
                                <span class="marg-l">{{address.city}}</span>
                            </span>
                            <button (click)="openModal(template,i)" title="Suppression d'adresse" placement="bottom"
                                class="button  pull-right">
                                <i class="flaticon-garbage  cursor-pointer"></i>
                            </button>
                            <button (click)="editAddress(i)" title="Modification d'adresse" placement="bottom"
                                class="button btn-edit pull-right">
                                <i class="flaticon-edit-document cursor-pointer"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row block" id="change-password">
            <div class="col-xs-12">
                <h3 class="heading">Modifier votre mot de passe :</h3>
                <hr class="half_space">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="content">
                            <div class="row mb-22">
                                <div class="col-xs-4">
                                    <label>Mot de passe actuel * :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="password" class="inpt" placeholder="Actuel" [(ngModel)]="oldPassword">
                                </div>
                            </div>
                            <div class="row mb-22">
                                <div class="col-xs-4">
                                    <label>Nouveau mot de passe * :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="password" class="inpt" placeholder="Nouveau mot de passe..."
                                        [(ngModel)]="customer.password">
                                </div>
                            </div>
                            <div class="row mb-22">
                                <div class="col-xs-4">
                                    <label>Confirmer le nouveau mot de passe * :</label>
                                </div>
                                <div class="col-xs-8">
                                    <input type="password" class="inpt" placeholder="Confirmer..."
                                        [(ngModel)]="customer.confirmePassword">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-4">
                                </div>
                                <div class="col-xs-8">
                                    <div class="valider">
                                        <button id="v-pass" class="btn" (click)="updateUser()">Valider</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <p class="min">* minimum 8 caractères </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>Voulez-vous supprimer cette adresse?</p>
        <button type="button" class="btn btn-default" (click)="confirm()">Oui</button>
        <button type="button" class="btn btn-send" (click)="decline()">Non</button>
    </div>
</ng-template>